<template>
    <v-container fluid tag="section">
        <v-row justify="center">
            <v-col v-if="showYears" class="d-flex" cols="12" sm="4">
                <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" v-model="anio" :items="years" item-text="year"
                    item-value="year" label="Año" @change="loadDataNominas">
                </v-select>
            </v-col>
            <v-col cols="12" sm="12" style="padding:0px;margin:0px">
                <v-divider  />
            </v-col>
        </v-row>
        <v-row justify="center" v-if="showCaroucel">
            <!-- en el v-carousel  v-for = "(ite,i) in array_carousel" :key = "i"-->
            <v-col cols="12" sm="12" style="padding:0px;margin:10px 0px">
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                  <h3> Avisos</h3>
                  </v-expansion-panel-header>
                   <v-expansion-panel-content>
                    <v-carousel cycle class="" v-if="array_caroucel.length > 0">
                      <v-carousel-item  width="100%"   v-for = "(item,i) in array_caroucel" :key = "i" :style="(item.color_fondo != 'null' && item.tipo_aviso ==1) ? 'background-color:'+item.color_fondo +';padding: 30px 30px 50px 30px;' : (item.tipo_aviso == 1) ? 'padding: 30px 30px 50px 30px;': ''">
                          <!-- titulo -->
                          <div  v-if="item.tipo_aviso ==1">
                              <div class="contenido_html" v-html="item.contenido">

                              </div>
                          </div>

                          <div v-if="item.tipo_aviso ==2">
                                <div class="mob-carousel-img-container text-center" style="position: relative">
                                    <img @click="redirigir(item)" :src="baseUrl+'../assets/img/avisos_empleados/'+item.ruta_archivo" height="auto" style="max-width:100%">
                                </div>
                          </div>
                      </v-carousel-item>

                    </v-carousel>
                     <v-carousel cycle class="" v-else>
                      <v-carousel-item  width="100%"    :style="'padding: 30px 30px 50px 30px;'">
                        <div class="text-center">
                          <h4>NO HAY AVISOS DISPONIBLES</h4>
                        </div>
                      </v-carousel-item>
                     </v-carousel>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col v-if="showAlert" cols="12" sm="12">
                <v-alert align="center" dense min-height="25" type="warning" style="padding:0px">
                    <strong>No hay nóminas timbradas</strong>
                </v-alert>
            </v-col>
            <v-col v-else-if="showTable" cols="12" sm="12" class="bg-white border rounded shadow">
                <!--  -->
                <v-simple-table v-if="mostrar_totales">
		            <template v-slot:default>
                        <thead>
                            <tr>
                                <th style="font-weight: bold;" COLSPAN="5" class="text-center"> <h3>TOTAL INGRESOS DEL {{ anio }}</h3>  </th>
                            </tr>
                            <tr>
                                <th class="text-left" style="font-weight: bold;">
                                   <h3>Percepciones</h3>
                                </th>
                                <th class="text-center" style="font-weight: bold;">
                                    <h3>ISR</h3>
                                </th>
                                <th class="text-right" style="font-weight: bold;">
                                     <h3>Deducciones</h3>
                                </th>

                                <th class="text-right" style="font-weight: bold;">
                                     <h3>Subsidio al empleo</h3>
                                </th>

                                <th class="text-right" style="font-weight: bold;">
                                     <h3>Líquido</h3>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-left" style="font-weight: bold;" >
                                     <h3>${{toCurrency(data_importes.total_percepcion)}}</h3>

                                </td>
                                <td class="text-center" style="font-weight: bold;">
                                    <h3>${{toCurrency(data_importes.total_isr)}}</h3>
                                </td>
                                <td class="text-right" style="font-weight: bold;">
                                     <h3>${{toCurrency(data_importes.total_deducciones)}}</h3>
                                </td>

                                <td class="text-right" style="font-weight: bold;">
                                     <h3>${{toCurrency(data_importes.total_subsidio)}}</h3>
                                </td>

                                <td class="text-right" style="font-weight: bold;">
                                     <h3>${{toCurrency(((data_importes.total_percepcion+data_importes.total_subsidio)-data_importes.total_deducciones))}}</h3>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <!--  -->
                <v-client-table :data="data" :columns="columns" :options="options" ref="table" style="text-align:center">
                    <template slot="primeraQuincena" slot-scope="nomina">
                        <template v-if="nomina.row.primeraQuincena">
                            <template v-for="(item, index) in nomina.row.primeraQuincena">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" color="#e70c0e" small @click="imprimirPDF(nomina.row,1,index, 1)">
                                            <v-icon>fas fa-file-pdf</v-icon>PDF
                                        </v-btn>
                                    </template>

                                    <span>Descargar PDF</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" color="#f57304" small @click="imprimirXML(nomina.row,1,index, 1)">
                                            <v-icon>fas fa-file-excel</v-icon>XML
                                        </v-btn>
                                    </template>
                                    <span>Descargar XML</span>
                                </v-tooltip>
                              </template>
                        </template>
                        <template v-else>
                            <strong>NO HAY CFDI PARA ESTA FECHA</strong>
                        </template>
                    </template>
                    <template slot="segundaQuincena" slot-scope="nomina">
                        <template v-if="nomina.row.segundaQuincena">
                            <template v-for="(item, index) in nomina.row.segundaQuincena">
                              <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                      <v-btn v-on="on" small color="#e70c0e" @click="imprimirPDF(nomina.row,1,index,2)">
                                          <v-icon>fas fa-file-pdf</v-icon>PDF
                                      </v-btn>
                                  </template>
                                  <span>Descargar PDF</span>
                              </v-tooltip>

                              <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                      <v-btn v-on="on" color="#f57304" small @click="imprimirXML(nomina.row,1,index,2)">
                                          <v-icon>fas fa-file-excel</v-icon>XML
                                      </v-btn>
                                  </template>
                                  <span>Descargar XML</span>
                              </v-tooltip>
                            </template>
                        </template>
                        <template v-else>
                            <v-row justify="center">
                                <strong >NO HAY CFDI PARA ESTA FECHA</strong>
                            </v-row>

                        </template>
                    </template>
                    <template v-slot:extraordinaria="{row,index}" >
                        <template v-if="row.extraordinaria">
                            <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" @change="cambiarSelect($event,index)"  :items="extraordinariasItems(row.extraordinaria)" item-text="year"
                              item-value="year" label="Nómina extraordinaria" >
                            </v-select>
                            <v-tooltip bottom v-if="row.selectedExtraordinaria !== null">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" small color="#e70c0e" @click="imprimirPDF(row,2,0)">
                                        <v-icon>fas fa-file-pdf</v-icon>PDF
                                    </v-btn>
                                </template>
                                <span>Descargar PDF</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="row.selectedExtraordinaria !== null">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" color="#f57304" small @click="imprimirXML(row,2,0)">
                                        <v-icon>fas fa-file-excel</v-icon>XML
                                    </v-btn>
                                </template>
                                <span>Descargar XML</span>
                            </v-tooltip>
                        </template>
                        <template v-else>
                            <v-row justify="center">
                                <strong >NO HAY CFDI PARA ESTA FECHA</strong>
                            </v-row>

                        </template>
                    </template>

                    <!-- suplencia -->
                    <template v-slot:suplencia="{row,index}" >
                        <template v-if="row.suplencia">
                            <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" @change="cambiarSelectSuplencia($event,index)"  :items="suplenciaItems(row.suplencia)" item-text="year"
                              item-value="year" label="Nómina suplencia" >
                            </v-select>
                            <v-tooltip bottom v-if="row.selectedSuplencia !== null">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" small color="#e70c0e" @click="imprimirPDF(row,3,0)">
                                        <v-icon>fas fa-file-pdf</v-icon>PDF
                                    </v-btn>
                                </template>
                                <span>Descargar PDF</span>
                            </v-tooltip>

                            <v-tooltip bottom v-if="row.selectedSuplencia !== null">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" color="#f57304" small @click="imprimirXML(row,3,0)">
                                        <v-icon>fas fa-file-excel</v-icon>XML
                                    </v-btn>
                                </template>
                                <span>Descargar XML</span>
                            </v-tooltip>
                        </template>
                        <template v-else>
                            <v-row justify="center">
                                <strong >NO HAY CFDI PARA ESTA FECHA</strong>
                            </v-row>

                        </template>
                    </template>
                    <!-- supplemcia -->
                </v-client-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data:function(){
        return {
            //panel de avisos
            panel: [0],
            //banderas para mostrar lo diferentes componentes
            showYears:false,
            showAlert:false,
            showTable:false,
            //columns: ["mes","primeraQuincena","segundaQuincena","extraordinaria","suplencia"], //TODO descomentar para activar suplencias
            columns: ["mes","primeraQuincena","segundaQuincena","extraordinaria"],
            options: {
                headings: {
                    mes             : 'Mes',
                    primeraQuincena : "Primera quincena",
                    segundaQuincena : "Segunda quincena",
                    extraordinaria  : "Extraordinarias",
                    //suplencia       : "Suplencias", //TODO descomentar para activar suplencias

                },
                sortable: [],
                texts: {
                    count:"",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: false,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 10,
                perPageValues: [5, 10, 15, 20],

                templates:{
                }
            },

            anio:null,
            years:[],
            dataNominas:[],
            data:[],
            currentYear:null,
            showCaroucel :false,
            array_caroucel : [],
            data_importes : [],
            mostrar_totales: false
        }
    },
    computed:{
        ...mapState(["user","token","baseUrl"]),
    },
    async mounted(){
        this.$NProgress.done();
        this.currentYear = new Date().getFullYear()
        this.get_data_ajustes();

        await this.loadYears()


    },
    methods: {
      async get_data_ajustes(){
            this.showCaroucel = false;
             try{

                let response = await this.$http.get("get-info-dependencia");

                if(response.data.response){
                    this.mostrar_totales = (response.data.dependencia.totales_colapsado == 1) ? true: false;
                    this.array_caroucel = response.data.data;
                    this.showCaroucel = true;
                }else {
                    this.showCaroucel = false;
                }


            }catch(error){
                this.array_caroucel = [];
                this.showCaroucel = false;
            }
        },

        async loadYears(){
            this.years = [];
            this.dataNominas = [];
            this.data = []
            this.anio = null;
            this.showYears = false;
            this.showAlert = false;
            this.showTable = false;
            try{
                let form = new FormData();
                // form.append("tipo_nomina",this.tipoNomina);
                form.append("id_empleado",this.user.id_empleado);
                form.append("rfc",this.user.rfc);
                let response = await this.$http.post("get-years",form);
                if(response.data.response){
                    this.years = response.data.years;

                    this.years.forEach((el)=>{
                      if(el == this.currentYear){
                        this.anio = `${this.currentYear}`
                        this.loadDataNominas()
                      }
                    })
                    this.showYears = true;
                } else {
                    this.years = [];
                    this.showAlert = true;
                }

            }catch(error){
                this.years = [];
            }
        },
        async loadDataNominas(){
            this.showTable = false;
            this.showAlert = false;
            this.dataNominas = []
            this.data = []

             try{
                  let form = new FormData();
                  form.append("id_empleado",this.user.id_empleado);
                  form.append("anio",this.anio);
                  form.append("rfc",this.user.rfc);
                  let response = await this.$http.post("get-datos-nomina-ord-comp",form);
                  if(response.data.response){
                      this.dataNominas = response.data.data;
                      for (const property in this.dataNominas) {
                        this.dataNominas[property].selectedExtraordinaria = null
                        this.dataNominas[property].selectedSuplencia = null
                        this.data.push(this.dataNominas[property])
                      }
                      this.data_importes = response.data.importes

                      this.showTable = true;
                  }else {
                      this.showAlert = true;
                  }

            }catch(error){
                this.dataNominas = [];
                this.data = [];

                this.showTable = true;
            }
        },
        imprimirPDF(data,tipo,index, quincena = null){
            var extension = '.pdf';
            var file_path = "";
            if(tipo == 1){
                let selected = null
                if(quincena == 1){
                  selected = data.primeraQuincena
                }else{
                  selected = data.segundaQuincena
                }

                file_path = "assets/cfdi/timbrados/"+selected[index].file_path+"pdf/"+selected[index].file_name+extension;
                window.open(this.baseUrl + "download-files?token="+this.token+"&file_name=" + selected[index].file_name+"&file_path="+file_path+"&extension="+extension,"_blank");

            }else if(tipo == 2){
                let seleccionado = data.selectedExtraordinaria

                let selected = data.extraordinaria.filter((el)=> el.nombre == seleccionado)[index]

                file_path =  'assets/cfdi/timbradosNominaExtraordinaria/'+selected.file_path+'pdf/'+selected.file_name+extension;
                if(selected.file_path == null){
                    file_path =  'assets/cfdi/timbradosNominaExtraordinaria/pdf/'+selected.file_name+extension;
                }

                window.open(this.baseUrl + "download-files?token="+this.token+"&file_name=" + selected.file_name+"&file_path="+file_path+"&extension="+extension,"_blank");
            }else if(tipo == 3){
                let seleccionado = data.selectedSuplencia
                let selected = data.suplencia.filter((el)=> el.nombre == seleccionado)[index]
                file_path = "assets/cfdi/timbrados/"+selected.file_path+"pdf/"+selected.file_name+extension;

                window.open(this.baseUrl + "download-files?token="+this.token+"&file_name=" + selected.file_name+"&file_path="+file_path+"&extension="+extension,"_blank");
            }
        },
        imprimirXML(data,tipo, index, quincena = null){
            var extension = '.xml';
            var file_path = "";
            if(tipo == 1){ //si es diferente de extraordinaria

                let selected = null
                if(quincena == 1){
                  selected = data.primeraQuincena
                }else{
                  selected = data.segundaQuincena
                }

                file_path = "assets/cfdi/timbrados/"+selected[index].file_path+"xml/"+selected[index].file_name+extension;
                window.open(this.baseUrl + "download-files?token="+this.token+"&file_name=" + selected[index].file_name+"&file_path="+file_path+"&extension="+extension, "_blank");
            }else if(tipo == 2){
                let seleccionado = data.selectedExtraordinaria

                let selected = data.extraordinaria.filter((el)=> el.nombre == seleccionado)[index]
                file_path =  'assets/cfdi/timbradosNominaExtraordinaria/'+selected.file_path+'xml/'+selected.file_name+extension;
                if(selected.file_path == null){
                    file_path =  'assets/cfdi/timbradosNominaExtraordinaria/xml/'+selected.file_name+extension;
                }

                window.open(this.baseUrl + "download-files?token="+this.token+"&file_name=" + selected.file_name+"&file_path="+file_path+"&extension="+extension, "_blank");
            }else if(tipo == 3){
                let seleccionado = data.selectedSuplencia
                let selected = data.suplencia.filter((el)=> el.nombre == seleccionado)[index]
                file_path = "assets/cfdi/timbrados/"+selected.file_path+"xml/"+selected.file_name+extension;
                window.open(this.baseUrl + "download-files?token="+this.token+"&file_name=" + selected.file_name+"&file_path="+file_path+"&extension="+extension, "_blank");
            }
        },

        extraordinariasItems(extraordinarias){
          let filter = [null];
          extraordinarias.forEach((el)=>{
            filter.push(el.nombre)
          })
          return filter
        },
        suplenciaItems(suplencias){
          let filter = [null];
          suplencias.forEach((el)=>{
            filter.push(el.nombre)
          })
          return filter
        },
        cambiarSelect(event,index){
          this.data[index-1].selectedExtraordinaria = event

          this.data =[...this.data];
          this.$forceUpdate();
        },

        cambiarSelectSuplencia(event,index){
          this.data[index-1].selectedSuplencia = event

          this.data =[...this.data];
          this.$forceUpdate();
        },

        redirigir(item){
          if(item.has_redirect == "1"){
            window.open(item.url_redirect, '_blank');
          }
        },
        toCurrency(value){
            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

    }

}
</script>
